import Vue from 'vue';
import { i18n } from '../locale';
import Idg from './Idg';
import Auth from '../auth/Auth';
import Dispatcher from '../dispatcher/Dispatcher';
import RouterManager from '../router/Router';
const envs = window.ci_envs || window.IDG_ENVS;
import screen from '../global';
import '../devices';
import _ from 'lodash';
import Notify from '../pwa/Notify';
const TAG = 'package/App';
Vue.config.optionMergeStrategies.depends = (toVal = [], fromVal = []) => {
    const depends = [
        ...fromVal,
        ...toVal,
    ];
    return _.uniqBy(depends, (depend) => {
        if (typeof depend === 'string') {
            const strs = depend.split('.');
            return strs[strs.length - 1];
        }
        else {
            return depend.variableName;
        }
    });
};
class App extends Idg {
    constructor(appOptions) {
        const { appid, packages, children } = appOptions;
        const appkey = envs.appkey;
        const channel = envs.channel;
        const channelOptions = {
            appkey,
            channel,
        };
        super(appid, channelOptions, [...(packages || []), ...[screen]], children);
        this.notify = new Notify();
        this.root = this;
        this.appkey = appkey;
        this.channel = channel;
        this.auth = new Auth(this);
        this.routerManager = new RouterManager(this);
        this.router = this.routerManager.router;
        this.dispatcher = new Dispatcher();
        this.i18n = i18n;
        this.serverHost = envs.host;
    }
    get screen() {
        const screenPkg = this.findPackageInstance('idg-global');
        const state = screenPkg.$store.state;
        return state.screen;
    }
    setState(key, val) {
        const screenPkg = this.findPackageInstance('idg-global');
        const store = screenPkg.$store;
        store.commit('setGlobal', { key, val });
    }
    getState(key) {
        const screenPkg = this.findPackageInstance('idg-global');
        const state = screenPkg.$store.state;
        return state.global[key];
    }
    init() {
        super.init();
        if (this.children) {
            this.children.forEach((child) => {
                child.setParent(this);
                child.setRoot(this);
                child.init();
            });
        }
    }
    startup() {
        this.init();
        this.register();
        this.inject();
        this.injectRoutes();
        this.render();
    }
    redirectLogin() {
        let search = window.location.search;
        if (search && search.indexOf('?') >= 0) {
            search = search.slice(1);
        }
        const querys = search.split('&');
        let refer = querys.find((query) => {
            const strs = query.split('=');
            return strs && strs[0] && strs[0] === 'refer';
        });
        if (refer) {
            refer = refer.split('=')[1];
            window.location.href = `${decodeURIComponent(refer)}#/login`;
        }
        else {
            this.router.push('/login');
        }
    }
    setLocale(locale) {
        this.i18n.locale = locale;
    }
    getLocale() {
        return this.i18n.locale;
    }
    getServerHost() {
        return this.serverHost;
    }
    setServerHost(host) {
        this.serverHost = host;
    }
    getBaseURL(idg) {
        if (window.USE_MOCK) {
            return '';
        }
        if (idg.appid === this.appid) {
            return this.getServerHost();
        }
        else {
            return this.getProxyURL();
        }
    }
    getProxyURL() {
        return this.getServerHost() + '/main.php/json/proxy/call?url=';
    }
    getToken() {
        return this.auth.getToken();
    }
    render() {
        // tslint:disable-next-line:no-shadowed-variable
        const { router, i18n } = this;
        return new Vue({
            i18n,
            router,
            render: (h) => h('router-view'),
        }).$mount('#app');
    }
    generateChannel() {
        return `${this.appid}.${this.appkey}.${this.channel}`;
    }
    graphJson() {
        return JSON.stringify(this.graph(this));
    }
    graph(idg) {
        const idgGraph = {
            appid: idg.appid,
            channelOptions: idg.getChannelOptions(),
        };
        if (idg.children && idg.children.length > 0) {
            idgGraph.children = idg.children.map((child) => this.graph(child));
        }
        if (idg.packages && Object.keys(idg.packages).length > 0) {
            idgGraph.packages = idg.packages.map((pkg) => {
                return this.graphPackage(pkg, idg);
            });
        }
        return idgGraph;
    }
    graphPackage(pkg, idg) {
        const idgGraphPackage = {
            name: pkg.name,
        };
        let depends = [];
        if (pkg.components && Object.keys(pkg.components).length > 0) {
            if (pkg.apis) {
                idgGraphPackage.apis = Object.keys(pkg.apis).map((apiName) => {
                    return apiName;
                });
            }
            Object.keys(pkg.components).forEach((componentName) => {
                let Ctor;
                const componentId = this.generateId(componentName, pkg, idg);
                if (idg.components[componentId]) {
                    Ctor = idg.components[componentId];
                }
                if (Ctor && Ctor.options && Ctor.options.depends) {
                    const filteredDepends = this.filterDepends(Ctor.options.depends, 'api');
                    depends = [
                        ...depends,
                        // 取组件的依赖
                        ...filteredDepends
                            .map((depend) => {
                            return this.generateId(depend.id, pkg, idg);
                        })
                            .filter((dependId) => {
                            return dependId.split('.').length === 3;
                        }),
                    ];
                }
            });
        }
        if (depends.length > 0) {
            idgGraphPackage.depends = _.uniq(depends);
        }
        return idgGraphPackage;
    }
}
export default App;
